module.exports = __webpack_public_path__ + "static/media/blood-pressure.00007084.png";